import { journeyAction, } from './base';

import { JourneyActionVoiceStopRecording as JourneyActionVoiceStopRecordingBase, } from 'atlas-shared';

export const JourneyActionVoiceStopRecording = journeyAction({
  ...JourneyActionVoiceStopRecordingBase,
  icon: 'RecordStop',
});
